module.exports = __webpack_public_path__ + "static/media/replay.031e80b8.svg";